<template>
  <v-expansion-panel
    @click="onContactPanelClick()"
    :class="disabled ? 'v-expansion-panel--disabled' : ''"
    :readonly="disabled"
  >
    <v-expansion-panel-header
      class="process-step-header"
      color="primary-color"
      ref="contactDetailsStep"
    >
    <v-container>
      <v-row no-gutters>
        <v-col cols="2" sm="1">
          <div class="process-number">{{processNumber}}</div>
        </v-col>
        <v-col cols="10" sm="11">
          <div class="process-step-name">{{messages.contactDetailsStep}}</div>
        </v-col>
      </v-row>
    </v-container>
    <span aria-live="polite" class="screen-reader-only">{{messages.contactDetailsStep}} {{ stepExpanded ? messages.ariaExpanded : messages.ariaCollapsed }}</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content v-if="!disabled">
      <v-card>
        <div class="alert-error-section">
           <v-alert v-if="configuration.uiFields.CustRef" ref="custRef" v-model="formAlerts.CustRef" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.custRefAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.LastName" ref="lastNameRef" v-model="formAlerts.LastName" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.lastNameErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.FirstName" ref="firstNameRef" v-model="formAlerts.FirstName" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.firstNameErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.DOB" ref="dobRef" v-model="formAlerts.DOB" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.DOBErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.Email" ref="emailRef" v-model="formAlerts.Email" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.emailErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.ConfirmEmail" ref="confirmEmailRef" v-model="formAlerts.ConfirmEmail" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.confirmEmailErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.CountryCode" ref="countryCodeRef" v-model="formAlerts.CountryCode" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.countryCodeErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.Phone" ref="phoneRef" v-model="formAlerts.Phone" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.phoneErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.ConfirmPhone" ref="confirmPhoneRef" v-model="formAlerts.ConfirmPhone" class="alert-error" close-label="Close Alert" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.comfirmPhoneErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.FormattedPhone" ref="formattedPhoneRef" v-model="formAlerts.FormattedPhone" class="alert-error" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.countryCodeErrorAlert}}
          </v-alert>
          <v-alert v-if="configuration.uiFields.Notes" ref="notesRef" v-model="formAlerts.Notes" class="alert-error" tile type="error" role="alert" tabindex="0" dismissible>
            {{messages.notesErrorAlert}}
          </v-alert>
        </div>
        <v-card-text class="info-text relative">
            <v-row no-gutters>
              <v-col cols="12" sm="8">
          <div>
            <div class="info-text-strong">{{messages.contactDetailsContentChosenText}}</div>
            <div>
              <div v-for="(service, index) in selectedServices" :key="index">
              {{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}
                <div v-if="configuration.multiplePeopleEnabled && (service.adult || service.child)" class="confirmation-service-adult">
                  (<span v-if="service.adult">{{service.adult}} <span v-if="service.adult == 1">{{messages.commonAdultText}}</span><span v-else>{{messages.commonAdultsText}}</span></span>
                  <span v-if="service.adult && service.child">, </span>
                  <span v-if="service.child">{{service.child}} <span v-if="service.child == 1">{{messages.commonChildText}}</span><span v-else>{{messages.commonChildrenText}}</span></span>)
                </div>
              </div>
              <div v-if="selectedBranch && selectedBranch.name">
                {{getBranchAddress(selectedBranch, 'branchSelected')}}</div>
              <div>{{selectedDate | formatDate(selectedLanguage)}} {{selectedTimeSlot | formatTime(selectedLanguage)}}</div>
              <div
                v-if="checkShowPricesAndServicePrice"
              >{{messages.totalCost}}: {{totalCost}} {{messages.chooseServiceContentCurrency}}</div>
              <div
                v-if="checkShowPricesAndCondPrice"
              >{{messages.totalCost}}: {{condTotalCost}} {{messages.chooseServiceContentCurrency}}</div>
            </div>
          </div>
              </v-col>
              <v-col cols="12" sm="4">
          <v-btn
            icon
            :ripple="false"
            :aria-label="messages.ariaResetData"
            color="error"
            class="full-wide-mobile reset-btn"
            ref="confirmResetDataRef"
            @click="confirmResetDataModal"
          >
          {{messages.deleteAppointmentButtonText}}
          </v-btn>
              </v-col>
            </v-row>
        </v-card-text>
        <v-form ref="form" v-model="valid" v-if="!disabled">
          <div
            class="info-text"
          >{{messages.contactDetailsContentMobileVerificationText}}</div>
          <div
            class="fields-wrapper"
            v-for="(field, index) in configuration.uiFields"
            :key="index"
          >
            <phone-field
              v-if="field.name === 'Phone' && loadMobileVerification"
              @phone-verified="phoneVerified"
              @phone-dialog="setfocus()"
              :field="field"
              :read-only="readOnly"
              :email="localContactDetails.Email"
              :phone-details="tempPhoneDetails"
              @temp-phone="getPhone"
              :custRef="localContactDetails.CustRef"
              :show-autocomplete="true"
              :show-appointments="true"
              :services="selectedServices"
              :branch="selectedBranch"
              :time="selectedTimeSlot"
              :date="selectedDate"
              @is-phone-valid="setPhoneValidity"
            ></phone-field>
            <birth-picker
              v-if="field.name === 'DOB'"
              :field="field"
              @birth-selected="birthSelected"
              @temp-birth="getDob"
              :dob = "tempDOB"
            ></birth-picker>
            <v-textarea
              v-if="field.name === 'Notes'"
              class="input-field focused-border"
              outline
              :rules="field.m === 1 ? (rules[field.name] ? [rules[field.name], rules.required] : [rules.required]) : (rules[field.name] ? [rules[field.name]] : [])"
              :id="field.name"
              :aria-required="field.m === 1 ? true: false"
              v-model="localContactDetails[field.name]"
              :label="field.m === 1 ? messages[field.name] +  ' *': messages[field.name]"
            >
              <!--div slot="label" :for="field.name">{{messages[field.name]}}</div-->
            </v-textarea>
            <v-text-field
              class="input-field focused-border"
              outline
              v-if="field.name !== 'DOB' && field.name !== 'Phone' && field.name !== 'Notes' && field.name !== 'BookingId'"
              :rules="field.m === 1 ? (rules[field.name] ? [rules[field.name], rules.required] : [rules.required]) : (rules[field.name] ? [rules[field.name]] : [])"
              :id="field.name"
              :aria-required="field.m === 1 ? true: false"
              :aria-describedby="getLabelDescribedBy(field.name)"
              v-model="localContactDetails[field.name]"
              @blur="field.name === 'CustRef' || field.name === 'Email' ? revalidateField(field.name) : false"
            >
              <div slot="label" :for="field.name">{{field.m === 1 ? messages[field.name] + ' *': messages[field.name]}}</div>
            </v-text-field>
            <span v-if="(field.name === 'Email') && (!getValidationEmail())" class="hide-validation" id="emailValidation" >{{ messages.emailErrorAlert }}</span>
            <span v-if="(field.name === 'ConfirmEmail') && (!getValidationConfirmEmail())" class="hide-validation" id="confirmEmailValidation" >{{ messages.confirmEmailErrorAlert }}</span>
            <span v-if="(field.name === 'ConfirmPhone') && (!getValidationConfirmPhone())" class="hide-validation" id="confirmPhoneValidation" >{{ messages.comfirmPhoneErrorAlert }}</span>
          </div>
          <div v-if="configuration.customProperties && configuration.customProperties.enabled">
            <div
              class="fields-wrapper"
              :key="index"
              v-for="(field, index) in customPropertiesListActiveAndDependencyFiltered"
            >
              <v-select
                v-if="field.parameterType === 'MultipleChoice'"
                class="focused-border custom-field full-wide-select-mobile"
                :id="'customFields' + (index + 1)"
                outline
                :items="field.values"
                item-value="value"
                :label="field.mandatory ? getCustomFieldLabel(index) + ' *': getCustomFieldLabel(index)"
                v-model="customPropertiesSelection[field.parameterName]"
                :hint="getCustomFieldInfo(index)"
                :persistent-hint="isCustomFieldInfoPersistent(index)"
                :aria-label="getCustomFieldLabelAndInfo(index)"
                :rules="field.mandatory ? [rules.required] : []"
                @change="customFieldSelectionChanged()"
              >
                <template v-slot:selection="data">
                  {{ getCustomFieldValueLabel(data) }}
                </template>
                <template v-slot:item="data">
                  {{ getCustomFieldValueLabel(data) }}
                </template>
              </v-select>
              <MultipleSelectionComboBox
                v-if="field.parameterType === 'MultipleSelection'"
                :index="index"
                :field="field"
                :custom-properties-list-active="customPropertiesListActiveAndDependencyFiltered"
                @update-cf-selection="updateCFSelection"
              >
              </MultipleSelectionComboBox>
              <v-text-field
                v-if="field.parameterType === 'EditBox'"
                class="input-field focused-border"
                outline
                :id="'customFields' + (index + 1)"
                :label="field.mandatory ? getCustomFieldLabel(index) + ' *': getCustomFieldLabel(index)"
                :hint="getCustomFieldInfo(index)"
                :persistent-hint="isCustomFieldInfoPersistent(index)"
                :aria-label="getCustomFieldLabelAndInfo(index)"
                :rules="field.mandatory ? [rules.required] : []"
                v-model="customPropertiesSelection[field.parameterName]"
              >
              </v-text-field>
              <v-textarea
                v-if="field.parameterType === 'TextArea'"
                class="input-field focused-border"
                outline
                :id="'customFields' + (index + 1)"
                :label="field.mandatory ? getCustomFieldLabel(index) + ' *': getCustomFieldLabel(index)"
                :hint="getCustomFieldInfo(index)"
                :persistent-hint="isCustomFieldInfoPersistent(index)"
                :aria-label="getCustomFieldLabelAndInfo(index)"
                :rules="field.mandatory ? [rules.required] : []"
                v-model="customPropertiesSelection[field.parameterName]"
              >
              </v-textarea>
            </div>
          </div>
          <div
            class="notification-type"
            v-if="configuration.showNotificationType && rules.notificationType"
          >
            <v-radio-group
              :class="['notification-group-radio', 'radioGroupLabelRequired']"
              v-model="notificationType"
              row
              :rules="[rules.notificationType]"
            >
            <template v-slot:label>
              <span>{{messages.notifyUserByText}}</span>
            </template>
              <v-radio :ripple="false" mandatory value="sms" :label="messages.Phone" :aria-label="messages.ariaMobileNumber">
              </v-radio>
              <v-radio :ripple="false" mandatory value="email" :label="messages.Email" :aria-label="messages.ariaEmail">
              </v-radio>
            </v-radio-group>
          </div>
          <!--div>{{ configuration.customProperties }}</div-->
          <appointment-list
            v-if="loadAppointmentList"
            :existing-appointments="existingAppointments"
            :phone="localContactDetails.formattedPhone"
            :email="localContactDetails.Email"
            :custRef="localContactDetails.CustRef"
            :time="selectedTimeSlot"
            :date="selectedDate"
            :services="selectedServices"
            :status="restrictStatus"
            @appointment-deleted="appointmentDeleted"
          ></appointment-list>
          <v-checkbox
            :ripple="true"
            aria-labelledby="agreement"
            class="info-text agreement"
            v-model="agreement"
            required
            :rules="[rules.agreement]"
            >
            <div slot="label" id="agreement"><span ref='agreementHtml1' v-html="messages.agreementHtml1" @click.stop.prevent="showModalDialog1"></span>&nbsp;<span v-html="messages.agreementHtml2" ref='agreementHtml2' @click.stop.prevent="showModalDialog2"></span></div>
          </v-checkbox>
          <modal-dialog
            :dialog="dialog"
            :dialogMessage="dialogMessage"
            :dialogTitle="dialogTitle"
            :dialogButtonText="dialogButtonText"
            :dialogButtonConfirmText="dialogButtonConfirmText"
            @confirmmodal="clearBooking"
            @closemodal="hideDialog">
          </modal-dialog>
          <confirm-change-dialog
            :changedDetails="changedObject"
            :showDialog="showConfirmDialog"
            @cancel="goBackToConfirm"
            @overwrite="continueConfirmOverwrite"
            @donotoverwrite="continueConfirm"
          />
        </v-form>
      </v-card>
      <v-btn
        :ripple="false"
        text
        class="submit"
        @click="onSubmit"
        :disabled="status==='submitting' || (!phoneIsVerified && configuration.sendConfirm)|| tooManyAppointments || !agreement || !valid || !isPhoneValid"
        id='contactStepCreateAppointmentButton'
        ref="contactStepRefBtn"
        :aria-label="messages.createAppointmentButtonText"
      >
        <div v-if="status === ''">{{messages.createAppointmentButtonText}}</div>
        <v-progress-circular role="progressbar" indeterminate class="progress-bar" v-else></v-progress-circular>
      </v-btn>
      <v-alert role="alert" :value="confirmError" type="error">{{confirmErrorMessage}}</v-alert>
      <vue-recaptcha
        v-if="phoneIsVerified && !tooManyAppointments && configuration.captchaEnabled"
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        size="invisible"
        badge="inline"
        :sitekey="configuration.captchaSiteKey"
      ></vue-recaptcha>
    </v-expansion-panel-content>
    <v-alert v-if="disabled" ref="disabled" v-model="formAlerts.disabled" class="alert-error" close-label="Close Alert" tile type="error" role="alert" dismissible>
            {{messages.disabledStepContactStep}}
    </v-alert>
  </v-expansion-panel>
</template>
<script>
import RestService from '../services/restService'
import DataService from '../services/dataService'
import FormatService from '../services/formatService'
import { mapActions, mapState, mapGetters } from 'vuex'
import PhoneField from '../components/PhoneField'
import AppointmentList from '../components/AppointmentList'
import ModalDialog from '../components/Modal'
import VueRecaptcha from 'vue-recaptcha'
import { eventHub } from '../utils/eventhub'
import BirthPicker from '../components/BirthPicker'
import MultipleSelectionComboBox from '../components/MultipleSelectionComboBox'
import ConfirmChangeDialog from '../components/ConfirmChangeDialog'
export default {
  name: 'ContactStep',
  props: [
    'disabled',
    'processNumber',
    'loadMobileVerification',
    'loadAppointmentList',
    'startPage',
    'urlParams',
    'currentPanelOpen'
  ],
  mixins: [RestService, DataService, FormatService],
  components: {
    PhoneField,
    AppointmentList,
    VueRecaptcha,
    ModalDialog,
    BirthPicker,
    MultipleSelectionComboBox,
    ConfirmChangeDialog
  },
  data: () => ({
    valid: false,
    localContactDetails: {
      formattedPhone: '',
      Phone: '',
      Email: '',
      countryCode: '',
      LastName: '',
      FirstName: '',
      DOB: '',
      ConfirmEmail: '',
      ConfirmPhone: '',
      CustRef: '',
      Notes: ''
    },
    tempPhoneDetails: {
      countryCode: '',
      phone: '',
      verified: null
    },
    tempDOB: null,
    tempFieldVal: null,
    customPropertiesSelection: {},
    rules: {
      Email: false,
      ConfirmEmail: false,
      ConfirmPhone: false,
      agreement: false,
      notificationType: false,
      required: false
    },
    notificationType: '',
    readOnly: false,
    existingAppointments: [],
    restrictStatus: null,
    agreement: false,
    dialog: false,
    dialogMessage: '',
    dialogTitle: '',
    dialogButtonText: '',
    dialogButtonConfirmText: '',
    phoneIsVerified: false,
    tooManyAppointments: false,
    status: '',
    confirmError: false,
    confirmErrorMessage: null,
    recaptchaToken: '', // what is the use of this, why store it ?
    regexEmail: '',
    regexCustRef: '',
    showConfirmDialog: false,
    changedObject: {},
    recaptchaAlreadyChecked: false,
    stepExpanded: null,
    formAlerts:
    {
      FormattedPhone: false,
      Phone: false,
      Email: false,
      CountryCode: false,
      LastName: false,
      FirstName: false,
      DOB: false,
      ConfirmEmail: false,
      ConfirmPhone: false,
      CustRef: false,
      Notes: false,
      disabled: false
    },
    attempts: 0,
    isPhoneValid: true,
    customPropertiesHideList: {}
  }),
  computed: {
    ...mapState([
      'configuration',
      'selectedServices',
      'selectedBranch',
      'servicesTranslations',
      'branchTranslations',
      'selectedDate',
      'selectedTimeSlot',
      'contactDetails', // check
      'reservedAppointmentId',
      'messages',
      'selectedLanguage',
      'funcDebug',
      'condTotalCost'
    ]),
    ...mapGetters({
      totalCost: 'selectedServicesTotalCost',
      customSlotLength: 'customSlotLength',
      getSecurityToken: 'getSecurityToken'
    }),
    customPropertiesListActiveAndDependencyFiltered () {
      if (this.funcDebug) console.log('ContactStep:computed:customPropertiesListActiveAndDependencyFiltered')
      return this.customPropertiesListActive.reduce((accumulator, element) => {
        if (typeof (this.customPropertiesHideList[element.parameterName]) !== 'undefined') {
          if (!this.customPropertiesHideList[element.parameterName]) {
            // not to hide then shows it
            accumulator.push(element)
          }
        } else {
          // not defined, then show it
          accumulator.push(element)
        }
        return accumulator
      }, [])
    },
    customPropertiesListActive () {
      if (this.funcDebug) console.log('ContactStep:computed:customPropertiesListActive')
      if (this.configuration.customProperties.customPropertiesList) {
        const customPropertyFilteredList = this.configuration.customProperties.customPropertiesList.filter((element) => {
          if (element.onlyForServices && element.onlyForServices.length > 0) {
            const foundInService = this.selectedServices.some(r => element.onlyForServices.indexOf(r.publicId) >= 0)
            return element.active === true && foundInService
          } else {
            return element.active
          }
        })
        return customPropertyFilteredList
      } else {
        return []
      }
    },
    checkShowPricesAndCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'conditionalPrice'
    },
    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    },
    checkCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.priceCalc === 'conditionalPrice'
    }
  },
  watch: {
    selectedLanguage () {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    currentPanelOpen () {
      if (this.currentPanelOpen === 3) {
        this.stepExpanded = true
      } else {
        this.stepExpanded = false
      }
    }
  },
  methods: {
    ...mapActions([
      'setContactDetails',
      'setCustomFields'
    ]),
    getValidationEmail () {
      if (this.localContactDetails.Email && this.localContactDetails.Email.length > 0) {
        return this.regexEmail.test(this.localContactDetails.Email)
      } else {
        return true
      }
    },
    getValidationConfirmEmail () {
      if (this.localContactDetails.ConfirmEmail && this.localContactDetails.ConfirmEmail.length > 0 && this.localContactDetails.Email.length > 0) {
        return this.localContactDetails.ConfirmEmail === this.localContactDetails.Email
      } else {
        return true
      }
    },
    getValidationConfirmPhone () {
      if (this.localContactDetails.ConfirmPhone && this.localContactDetails.ConfirmPhone.length > 0 && this.tempPhoneDetails.phone.length > 0) {
        return this.localContactDetails.ConfirmPhone === this.tempPhoneDetails.phone
      } else {
        return true
      }
    },
    customFieldSelectionChanged () {
      if (this.funcDebug) console.log('ContactStep:methods:customFieldSelectionChanged')
      let recallChanged = false
      // check if the filtered customproperties are visible according to dependency
      if (this.configuration.customProperties.customPropertyDependencyList) {
        let newCustomPropertiesHideList = {}
        for (let u = 0; u < this.customPropertiesListActive.length; u++) {
          const cp = this.customPropertiesListActive[u]
          const foundInCustomPropertiesDependencyList = this.configuration.customProperties.customPropertyDependencyList.filter(r => {
            return r.dependentfield === cp.parameterName
          })
          if (foundInCustomPropertiesDependencyList.length > 0) {
            // if (this.funcDebug) console.log(cp.parameterName + ' has ' + foundInCustomPropertiesDependencyList.length + ' dependency')
            // check dependency value
            newCustomPropertiesHideList[cp.parameterName] = !foundInCustomPropertiesDependencyList.reduce((accumulator, currentCPD) => {
              const selectionCPS = this.customPropertiesSelection[currentCPD.prerequisitefield]
              if (selectionCPS) {
                const prerequValues = currentCPD.prerequisitevalues
                if (prerequValues.find((elem) => elem === selectionCPS)) {
                  return accumulator || true
                }
              }
              return accumulator
            }, false)
            // if the element is hidden, the selected value must be empty
            if (newCustomPropertiesHideList[cp.parameterName]) {
              switch (cp.parameterType) {
                case 'MultipleChoice':
                  this.customPropertiesSelection[cp.parameterName] = ''
                  break
                case 'MultipleSelection':
                  this.customPropertiesSelection[cp.parameterName] = []
                  break
                case 'EditBox':
                  this.customPropertiesSelection[cp.parameterName] = ''
                  break
                case 'TextArea':
                  this.customPropertiesSelection[cp.parameterName] = ''
                  break
              }
              if (newCustomPropertiesHideList[cp.parameterName] !== this.customPropertiesHideList[cp.parameterName]) {
                recallChanged = true
              }
            }
          } else {
            // if (this.funcDebug) console.log(cp.parameterName + ' has no dependency, so its visible')
            newCustomPropertiesHideList[cp.parameterName] = false
          }
        }
        this.customPropertiesHideList = newCustomPropertiesHideList
        if (recallChanged) {
          this.customFieldSelectionChanged()
        }
      } else {
        let newCustomPropertiesHideList = {}
        for (let u = 0; u < this.customPropertiesListActive.length; u++) {
          newCustomPropertiesHideList[this.customPropertiesListActive[u].parameterName] = false
        }
        this.customPropertiesHideList = newCustomPropertiesHideList
      }
    },
    getPhone (obj) {
      // stores phone details temporarily so not to lose phone contact details if appointment date is changed
      this.tempPhoneDetails = JSON.parse(JSON.stringify(obj))
    },
    getDob (date) {
      // stores dob temporarily so not to lose previously added date of birth if appointment date is changed
      this.tempDOB = date
    },
    setPhoneValidity (validity) {
      this.isPhoneValid = validity
    },
    updateCFSelection (data) {
      if (this.funcDebug) console.log('ContactStep:methods:updateCFSelection')
      this.customPropertiesSelection[data.parameterName] = data.selection
      // this.customFieldSelectionChanged()
    },
    getCustomFieldLabel (index) {
      return this.customPropertiesListActiveAndDependencyFiltered[index].labels[this.selectedLanguage.lang]
    },
    getCustomFieldInfo (index) {
      return this.customPropertiesListActiveAndDependencyFiltered[index].infos[this.selectedLanguage.lang]
    },
    isCustomFieldInfoPersistent (index) {
      if (this.customPropertiesListActiveAndDependencyFiltered[index].infos[this.selectedLanguage.lang].length > 0) {
        return true
      } else {
        return false
      }
    },
    getCustomFieldValueLabel (data) {
      // if (this.funcDebug) console.log('data: ' + data)
      let labels = data.item.labels
      return labels[this.selectedLanguage.lang]
    },
    getCustomFieldLabelAndInfo (index) {
      return this.customPropertiesListActiveAndDependencyFiltered[index].labels[this.selectedLanguage.lang] + ' - ' +
        this.customPropertiesListActiveAndDependencyFiltered[index].infos[this.selectedLanguage.lang]
    },
    // callbacks
    phoneVerified (verified, formattedPhone, phone, status, readOnly) {
      if (this.funcDebug) console.log('ContactStep:methods:phoneVerified')
      this.localContactDetails.Phone = phone
      if (verified && this.configuration.sendConfirm) {
        this.phoneIsVerified = verified
        this.localContactDetails.formattedPhone = formattedPhone
        this.readOnly = readOnly
        this.setNextFocus()
      } else {
        this.phoneIsVerified = verified
        this.localContactDetails.formattedPhone = formattedPhone
      }
    },
    setNextFocus () {
      // set focus after phone verification
      var el = this.$refs.form.$el
      var idx
      var found
      for (var i = 0; i < el.length; i++) {
        if (el[i].id === 'Phone') {
          idx = i + 1
          found = true
        }
        if (el[i].id === 'phoneCodeButton') {
          idx = i
          found = true
        }
      }
      if (found === true) {
        this.$nextTick(() => {
          this.$refs.form.$el[idx].focus()
        })
      }
    },
    birthSelected (birth) {
      this.localContactDetails.DOB = birth
    },
    appointmentDeleted (tooManyAppointments) {
      // This is to decide whether even after deleting there could be too many appointments (i.e. for the email address, or in the past)
      this.tooManyAppointments = tooManyAppointments
    },
    onCaptchaVerified (recaptchaToken) {
      if (this.funcDebug) console.log('ContactStep:methods:onCaptchaVerified')
      this.recaptchaToken = recaptchaToken
      if (!this.configuration.sendConfirm) {
        this.checkRestrictStatus(recaptchaToken)
      } else {
        this.confirmReserved(recaptchaToken)
      }
    },
    onCaptchaExpired () {
      if (this.funcDebug) console.log('ContactStep:methods:onCaptchaExpired')
      this.$refs.recaptcha.reset()
    },
    showModalDialog1 () {
      if (this.messages.agreementHtml1.indexOf('<a') >= 0) {
        this.dialogMessage = this.messages.dialog1Text
        this.dialogTitle = this.messages.dialog1Title
        this.dialogButtonText = this.messages.dialog1ButtonText
        this.dialogButtonConfirmText = ''
        this.dialog = true
      }
    },
    showModalDialog2 () {
      if (this.messages.agreementHtml2.indexOf('<a') >= 0) {
        this.dialogMessage = this.messages.dialog2Text
        this.dialogTitle = this.messages.dialog2Title
        this.dialogButtonText = this.messages.dialog2ButtonText
        this.dialogButtonConfirmText = ''
        this.dialog = true
      }
    },
    confirmResetDataModal () {
      this.dialogMessage = this.messages.clearBookingConfirmText
      this.dialogTitle = this.messages.clearBookingConfirmTitle
      this.dialogButtonConfirmText = this.messages.clearBookingYesText
      this.dialogButtonText = this.messages.clearBookingNoText
      this.dialog = true
    },
    hideDialog (dialogName) {
      this.dialog = false
      if (dialogName === this.messages.clearBookingConfirmTitle) {
        this.$nextTick(() => {
          this.$refs.confirmResetDataRef.$el.focus()
        })
      } else if (this.messages.agreementHtml1.indexOf(dialogName) !== -1) {
        this.$nextTick(() => {
          this.$refs.agreementHtml1.children[0].focus()
        })
      } else if (this.messages.agreementHtml2.indexOf(dialogName) !== -1) {
        this.$nextTick(() => {
          this.$refs.agreementHtml2.children[0].focus()
        })
      }
    },
    clearBooking () {
      this.dialog = false
      this.$emit('reset-data')
    },
    onSubmit () {
      if (this.funcDebug) console.log('ContactStep:methods:onSubmit')
      if (this.$refs.form.validate()) {
        this.status = 'submitting'
        if (this.configuration.captchaEnabled) {
          if (!this.recaptchaAlreadyChecked) {
            this.$refs.recaptcha.execute()
            this.recaptchaAlreadyChecked = true
          } else {
            this.onCaptchaVerified(this.recaptchaToken)
          }
        } else {
          this.recaptchaToken = false
          this.checkRestrictStatus(false)
        }
      }
      this.alertClose()
      for (var i in this.configuration.uiFields) {
        var fieldName = this.configuration.uiFields[i].name
        if (this.localContactDetails[fieldName] === '' && this.configuration.uiFields[fieldName].m === 1) {
          this.formAlerts[fieldName] = true
        }
      }
      if (this.formAlerts.CustRef) {
        this.$nextTick(() => {
          this.$refs.custRef.$el.focus()
        })
      } else if (this.formAlerts.LastName) {
        this.$nextTick(() => {
          this.$refs.lastNameRef.$el.focus()
        })
      } else if (this.formAlerts.FirstName) {
        this.$nextTick(() => {
          this.$refs.firstNameRef.$el.focus()
        })
      } else if (this.formAlerts.DOB) {
        this.$nextTick(() => {
          this.$refs.dobRef.$el.focus()
        })
      } else if (this.formAlerts.Email) {
        this.$nextTick(() => {
          this.$refs.emailRef.$el.focus()
        })
      } else if (this.formAlerts.ConfirmEmail) {
        this.$nextTick(() => {
          this.$refs.confirmEmailRef.$el.focus()
        })
      } else if (this.formAlerts.CountryCode) {
        this.$nextTick(() => {
          this.$refs.countryCodeRef.$el.focus()
        })
      } else if (this.formAlerts.Phone) {
        this.$nextTick(() => {
          this.$refs.phoneRef.$el.focus()
        })
      } else if (this.formAlerts.ConfirmPhone) {
        this.$nextTick(() => {
          this.$refs.confirmPhoneRef.$el.focus()
        })
      } else if (this.formAlerts.FormattedPhone) {
        this.$nextTick(() => {
          this.$refs.formattedPhoneRef.$el.focus()
        })
      } else if (this.formAlerts.Notes) {
        this.$nextTick(() => {
          this.$refs.notesRef.$el.focus()
        })
      }
    },
    alertClose () {
      this.formAlerts.CustRef = false
      this.formAlerts.LastName = false
      this.formAlerts.FirstName = false
      this.formAlerts.DOB = false
      this.formAlerts.Email = false
      this.formAlerts.ConfirmEmail = false
      this.formAlerts.CountryCode = false
      this.formAlerts.Phone = false
      this.formAlerts.ConfirmPhone = false
      this.formAlerts.FormattedPhone = false
      this.formAlerts.Notes = false
    },
    // internal functions
    checkRestrictStatus (token) {
      if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus')
      var _this = this
      this.checkRestrictions(this.localContactDetails.formattedPhone,
        this.localContactDetails.Email,
        this.selectedBranch,
        this.selectedServices,
        this.selectedDate,
        this.selectedTimeSlot,
        this.localContactDetails.CustRef).then(response => {
        if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus:checkRestrictions.then')
        this.restrictStatus = response.data

        if (response.data.message !== 'MULTIPLE_OK') {
          if (response.data.message.startsWith('ERROR_MULTI')) {
            if (response.data.message.includes('SAMEDAY')) { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT_SAMEDAY' } else { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT' }
          }
          _this.tooManyAppointments = true
          _this.status = ''
          _this.findAppointment(_this.localContactDetails, false, _this.getSecurityToken, false).then(response => {
            if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus:findAppointment.then')
            _this.existingAppointments = response.data
            if (_this.restrictStatus.message.startsWith('ERROR_MULTI') && _this.existingAppointments.length === 0) {
              // A violation to multiple appointments restrictions has been detected. But the returned appointment list is empty
              // That means that the restriction was violated by someone with the same email/phone but is not
              // exactly the same customer. In this case just show the correct error message, but do not show any appointments
              _this.existingAppointments = []
              _this.$emit('update:loadAppointmentList', true)
            }
            if (_this.existingAppointments.length > 0) {
              if (_this.existingAppointments[0].errorMessage === 'ERROR_CUSTOMERS_MULTIPLE') {
                if (_this.tooManyAppointments) { _this.restrictStatus.message = 'ERROR_CUSTOMERS_MULTIPLE' } else { _this.restrictStatus.message = 'INFO_CUSTOMERS_MULTIPLE' }
                _this.existingAppointments = []
              } else if (_this.existingAppointments[0].errorMessage === 'ERROR_SESSION_VIOLATION') {
                _this.restrictStatus.message = 'ERROR_SESSION_VALIDATION'
                _this.existingAppointments = []
              } else if (_this.existingAppointments[0].errorMessage === 'ERROR_NOT_ENOUGH_SEARCH_FIELDS') {
                _this.restrictStatus.message = 'ERROR_NOT_ENOUGH_SEARCH_FIELDS'
                _this.existingAppointments = []
              }
              _this.$emit('update:loadAppointmentList', true)
            }
          })
        } else {
          _this.recaptchaToken = false
          _this.confirmReserved()
        }
      })
    },
    confirmReserved () {
      if (this.funcDebug) console.log('ContactStep:methods:confirmReserved')
      var _this = this

      this.matchCustomer(this.localContactDetails, this.getSecurityToken).then(response => {
        if (response.data.errorMessage === undefined) {
          var changedDetails = response.data
          this.changedObject = {}

          if (changedDetails.dateOfBirth && _this.localContactDetails.DOB && changedDetails.dateOfBirth !== _this.localContactDetails.DOB) {
            // The date of birth has changed, so add it to the confirm dialog
            _this.changedObject.dateOfBirth = {}
            _this.changedObject.dateOfBirth.old = changedDetails.dateOfBirth
            _this.changedObject.dateOfBirth.new = _this.localContactDetails.DOB
          }
          if (changedDetails.email && _this.localContactDetails.Email && changedDetails.email !== _this.localContactDetails.Email) {
            // The date of birth has changed, so add it to the confirm dialog
            _this.changedObject.email = {}
            _this.changedObject.email.old = changedDetails.email
            _this.changedObject.email.new = _this.localContactDetails.Email
          }
          if (changedDetails.phone && _this.localContactDetails.formattedPhone && changedDetails.phone !== _this.localContactDetails.formattedPhone) {
            // The date of birth has changed, so add it to the confirm dialog
            _this.changedObject.phone = {}
            _this.changedObject.phone.old = changedDetails.phone
            _this.changedObject.phone.new = _this.localContactDetails.formattedPhone
          }
          if (changedDetails.firstName && _this.localContactDetails.FirstName && changedDetails.firstName !== _this.localContactDetails.FirstName) {
            // The date of birth has changed, so add it to the confirm dialog
            _this.changedObject.firstName = {}
            _this.changedObject.firstName.old = changedDetails.firstName
            _this.changedObject.firstName.new = _this.localContactDetails.FirstName
          }
          if (changedDetails.lastName && _this.localContactDetails.LastName && changedDetails.lastName !== _this.localContactDetails.LastName) {
            // The date of birth has changed, so add it to the confirm dialog
            _this.changedObject.lastName = {}
            _this.changedObject.lastName.old = changedDetails.lastName
            _this.changedObject.lastName.new = _this.localContactDetails.LastName
          }
          if (Object.entries(_this.changedObject).length > 0) { _this.showConfirmDialog = true } else { _this.continueConfirm(response.data) }
        } else {
          this.continueConfirm(response.data)
        }
      })
    },
    goBackToConfirm () {
      if (this.funcDebug) console.log('ContactStep:methods:goBackToConfirm')
      this.showConfirmDialog = false
      this.status = ''
      this.$nextTick(() => {
        this.$refs.contactStepRefBtn.$el.focus()
      })
    },
    continueConfirmOverwrite () {
      if (this.funcDebug) console.log('ContactStep:methods:continueConfirmOverwrite')
      this.showConfirmDialog = false
      if (this.changedObject.firstName) {
        this.localContactDetails.FirstName = this.changedObject.firstName.new
      }
      if (this.changedObject.lastName) {
        this.localContactDetails.LastName = this.changedObject.lastName.new
      }
      if (this.changedObject.email) {
        this.localContactDetails.Email = this.changedObject.email.new
      }
      if (this.changedObject.phone) {
        this.localContactDetails.formattedPhone = this.changedObject.phone.new
      }
      if (this.changedObject.dateOfBirth) {
        this.localContactDetails.DOB = this.changedObject.dateOfBirth.new
      }
      this.localContactDetails.allowOverwrite = true
      this.continueConfirm()
    },
    continueConfirm () {
      if (this.funcDebug) console.log('ContactStep:methods:continueConfirm')
      this.showConfirmDialog = false
      var _this = this
      let totalCostToSave = 0
      if (this.configuration.pricesEnabled) {
        totalCostToSave = this.checkCondPrice ? this.condTotalCost : this.totalCost
      }
      // copy custom fields to notes if needed
      let notesToSave = this.customPropertiesListActiveAndDependencyFiltered.reduce((previousArray, currentValue) => {
        if (currentValue.saveToNotesField) {
          let myString
          if (Array.isArray(_this.customPropertiesSelection[currentValue.parameterName])) {
            myString = currentValue.parameterName + ': '
            myString += _this.customPropertiesSelection[currentValue.parameterName].reduce((previousArray, currentValue) => {
              previousArray.push(currentValue)
              return previousArray
            }, []).join(', ')
          } else {
            myString = currentValue.parameterName + ': ' + _this.customPropertiesSelection[currentValue.parameterName]
          }
          previousArray.push(myString)
          return previousArray
        } else {
          return previousArray
        }
      }, (this.localContactDetails.Notes && this.localContactDetails.Notes.length > 0) ? [this.localContactDetails.Notes] : []).join('\n')
      // commented debug
      // this.localContactDetails.Notes = notesToSave
      this.$emit('cancel-timeout')
      this.confirmAppointment(
        this.selectedServices,
        this.reservedAppointmentId,
        this.localContactDetails,
        this.selectedLanguage.lang,
        this.recaptchaToken,
        totalCostToSave,
        this.customSlotLength,
        this.notificationType,
        this.customPropertiesSelection,
        notesToSave,
        this.getSecurityToken
      ).then(response => {
        if (this.funcDebug) console.log('ContactStep:methods:confirmReserved:confirmAppointment.then')
        switch (response.data.errorMessage) {
          case 'ERROR_TOO_MANY_RESCHEDULES':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.tooManyReschedules
            break
          case 'ERROR_EXPIRED':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorReservedExpired
            break
          case 'ERROR_SESSION_VIOLATION':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorSessionViolation
            break
          case 'ERROR_TOO_MANY_RESCHEDULES_AND_TOO_EARLY':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorTooManyReschedulesCancellation ? _this.messages.errorTooManyReschedulesCancellation.replace('%1', _this.configuration.maxDays).replace('%2', _this.configuration.rescheduleFutureDays) : _this.messages.errorGenericConfirm
            break
          default:
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorGenericConfirm
            break
          case '':
            // save contactDetails in the store
            _this.setContactDetails(_this.localContactDetails)
            _this.setCustomFields(_this.customPropertiesSelection)
            _this.$router.push({
              name: 'confirmation',
              params: {
                confirmation: response.data,
                startPage: _this.startPage,
                urlParams: _this.urlParams
              }
            })
            break
        }
      })
    },
    setfocus () {
      if (this.funcDebug) console.log('ContactStep:methods:setfocus')
      this.$nextTick(() => {
        if (this.$refs.contactDetailsStep) {
          this.$refs.contactDetailsStep.$el.focus()
        } else {
          this.attempts = 0
          this.retryfocus()
        }
        this.resetContactDetails()
      })
    },
    resetContactDetails () {
      if (typeof this.$refs.form !== 'undefined') {
        // reset contact details
        // this.$emit('update:loadAppointmentList', false)
        // this.verified = false
        // this.readOnly = false
        /* if (this.phoneIsVerified) {
          this.readOnly = true
        } else {
          this.readOnly = false
        } */
        // this.valid = false
        /* this.birthSelected('')
        var tempCountryCode = this.localContactDetails.countryCode
        this.$refs.form.reset()
        this.localContactDetails.countryCode = tempCountryCode */
      }
    },
    retryfocus () {
      if (this.funcDebug) console.log('ContactStep:methods:retryfocus')
      this.attempts++
      if (this.attempts < 5) {
        // setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.contactDetailsStep) {
            this.$refs.contactDetailsStep.$el.focus()
          } else {
            this.retryfocus()
          }
        })
        // }, 200)
      }
    },
    getLabelDescribedBy (name) {
      if (name === 'Email') {
        return 'emailValidation'
      } else if (name === 'ConfirmEmail') {
        return 'confirmEmailValidation'
      } else if (name === 'ConfirmPhone') {
        return 'confirmPhoneValidation'
      } else {
        return ''
      }
    },
    revalidateField (name) {
      var _this = this
      if (this.funcDebug) console.log(name + ':method:revalidateField')
      this.tempFieldVal = this.localContactDetails[name]
      this.localContactDetails[name] = ''
      function reapplyVal (name) {
        setTimeout(() => {
          _this.localContactDetails[name] = _this.tempFieldVal
        }, 100)
      }
      reapplyVal(name)
    },
    onContactPanelClick () {
      if (this.disabled) {
        this.formAlerts.disabled = true
      }
    }
  },
  mounted () {
    if (this.funcDebug) console.log('ContactStep:mounted')
    this.stepExpanded = false
    this.stepExpanded = 'collapsed'
    var _this = this
    this.regexEmail = new RegExp(this.configuration.regexEmail)
    this.regexCustRef = new RegExp(this.configuration.regexCustRef)

    // init phoneIsVerified to true if the phone number is not even in the selected ui fields
    // or if it is shown, but not mandatory
    if (!this.configuration.uiFields.hasOwnProperty('Phone') ||
      (this.configuration.uiFields.hasOwnProperty('Phone') && !this.configuration.uiFields.Phone.m && !this.configuration.sendConfirm)) {
      this.phoneIsVerified = true
    }

    // Initiate validation rules
    this.rules.required = v => !!v || (_this.messages.fieldRequired === undefined ? false : _this.messages.fieldRequired)
    this.rules.Email =
      v => {
        if (v && v.length > 0) {
          return _this.regexEmail.test(v) || (_this.messages.invalidEmail === undefined ? false : _this.messages.invalidEmail)
        } else {
          return true
        }
      }
    // console.log(this.rules.Email)
    this.rules.CustRef =
      v => {
        if (v && v.length > 0) {
          return _this.regexCustRef.test(v) || (_this.messages.invalidCustRef === undefined ? false : _this.messages.invalidCustRef)
        } else {
          return true
        }
      }
    this.rules.ConfirmPhone =
      v => {
        if (v && v.length > 0 && _this.tempPhoneDetails.phone.length > 0) {
          return v === _this.tempPhoneDetails.phone || (_this.messages.confirmPhoneError === undefined ? false : _this.messages.confirmPhoneError)
        } else {
          return true
        }
      }
    this.rules.ConfirmEmail =
      v => {
        if (v && v.length > 0 && _this.localContactDetails.Email.length > 0) {
          return v === _this.localContactDetails.Email || (_this.messages.confirmEmailError === undefined ? false : _this.messages.confirmEmailError)
        } else {
          return true
        }
      }
    this.rules.agreement = v => !!v || (_this.messages.agreementRequired === undefined ? false : _this.messages.agreementRequired)
    this.rules.notificationType = v => !!v || (_this.messages.notifyUserError === undefined ? false : _this.messages.notifyUserError)
    if (this.configuration.customProperties.customPropertyDependencyList) {
      this.customFieldSelectionChanged()
    }
    eventHub.$on('contact-step-focus', this.setfocus)
  }
}
</script>

<style scoped lang="scss">

.custom-field {
  width: 550px;
  margin: 0 0 0 24px;
}

@media only screen and (max-width: 599px) {
  .full-wide-mobile {
    width:100% !important;
    position: relative !important;
  }
  .full-wide-select-mobile {
    padding: 0 16px !important;
    width: 100% !important;
    margin: 0 !important;
  }
}

.alert-error {
  margin-bottom: 3px !important;
}

.alert-error-section {
  padding: 10px !important;
}

.radioGroupLabelRequired >>> legend {
  line-height: 1.5em;
  font-size: 0.825rem;
  display: block;
  width: 100%;
  margin-bottom: 8px;
}

.hide-validation {
  display: none;
}

</style>
